export const addSizeToImageUrl = (url: string, size: string) => {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}size=${size}`;
};
